<template>
  <div class="privacy-ios-container">
    <div class="content">
      <div class="main-container markdown-container">
        <div v-html="html" class="main"></div>
      </div>
    </div>
  </div>
</template>

<script>
import showdown from 'showdown'
import readMe  from '../../assets/privacy-ios-international.md';
export default {
  data () {
    return {
      md: readMe,
      html: ''
    }
  },

  mounted () {
    let converter = new showdown.Converter()
    let text = this.md.toString()
    this.html = converter.makeHtml(text)
  },

  components: {
    showdown
  }
}
</script>

<style lang="scss" scoped>
.privacy-ios-container {
  background-color: #fff;
  text-align: left;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/docsify/privacyIosInternational.vue